import Heading from '@service-victoria/component-library/components/Text/Heading';
import { colors } from '@service-victoria/component-library/utils';
import styled from 'styled-components';

export const List = styled.ul`
  color: ${colors.blueGrey};
  padding-left: 24px;
  margin-top: -4px;
`;

export const ListItem = styled.li`
  padding: 6px 0;
`;

export const CallToActionContainer = styled.div`
  margin-top: 12px;
  margin-bottom: 24px;
`;

export const H1 = styled(Heading.H1)`
  padding-bottom: 24px;
  font-weight: 600;
`;

export const Section = styled.div`
  margin-bottom: 60px;
`;
